import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { __ } from '@wordpress/i18n';
import { contextConnect, useContextSystem } from '@wp-g2/context';
import React from 'react';
import { Button } from '../Button';
import { useModalContext } from './Modal.Context';
import { ModalCloseButtonView } from './Modal.styles';

function ModalCloseButton(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'ModalCloseButton'),
      _useContextSystem$clo = _useContextSystem.closeLabel,
      closeLabel = _useContextSystem$clo === void 0 ? __('Close') : _useContextSystem$clo,
      showCloseLabel = _useContextSystem.showCloseLabel,
      otherProps = _objectWithoutProperties(_useContextSystem, ["closeLabel", "showCloseLabel"]);

  var _useModalContext = useModalContext(),
      dialog = _useModalContext.dialog;

  if (!showCloseLabel) return null;
  return /*#__PURE__*/React.createElement(ModalCloseButtonView, otherProps, /*#__PURE__*/React.createElement(Button, {
    isNarrow: true,
    onClick: dialog.hide,
    ref: forwardedRef,
    variant: "link"
  }, closeLabel));
}

export default contextConnect(ModalCloseButton, 'ModalCloseButton');